import { LicenceDetailsState } from '@urbanx/agx.agencies.client';

export function getAgencyLicenceStates(
  licences?: readonly { state?: string | null }[] | null
): LicenceDetailsState[] {
  const validStates = Object.values(LicenceDetailsState);
  return [
    ...new Set(
      licences?.flatMap(({ state }) => validStates.filter((validState) => validState === state)) ??
        []
    ),
  ];
}

export function getEmailTemplateStates(
  licences?: readonly { state?: string | null }[] | null
): (LicenceDetailsState.QLD | LicenceDetailsState.NSW)[] {
  const states = getAgencyLicenceStates(licences);
  const supportedStates: (LicenceDetailsState.QLD | LicenceDetailsState.NSW)[] = [
    LicenceDetailsState.QLD,
    LicenceDetailsState.NSW,
  ];
  return supportedStates.filter((state) => states.includes(state));
}
